module.exports = __webpack_public_path__ + "img/28_69.6bc18e32.png";